import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { QuantityDiscount } from "~/ProductDetails/ProductDetailPageResult";
import { PricingProduct } from "../../PricingProduct";
import DivideByUnitPrice from "../../DivideByUnitPrice";
import TableHeader from "./QuantityDiscountsTableHeader";

interface QuantityDiscountCardProps {
  product: PricingProduct;
  quantityDiscounts: QuantityDiscount[];
}

const QuantityDiscountsTableCard = ({
  product,
  quantityDiscounts,
}: QuantityDiscountCardProps) => {
  const { divideByUnit, divideQuantity } = product;

  const qtyDiscountsForTable = quantityDiscounts
    .slice()
    .sort((a, b) => b.price - a.price)
    .filter((discount) => discount.price !== product.price.price);

  const tableHeaderRounded = (index: number) => {
    if (index === 0) {
      return "rounded-tl-[3px]";
    }
    if (index === qtyDiscountsForTable.length - 1) {
      return "rounded-bl-[3px]";
    }
    return "";
  };

  const tableRowClassName = "text-sm leading-none py-2 text-left box-border";

  return (
    <table className="table qty-table-border box-border h-full mb-0">
      <tbody>
        {qtyDiscountsForTable.map((item, index) => (
          <tr
            key={item.price}
            data-testid={`quantity-discount-table-row-${index}`}
          >
            <th
              className={`${tableRowClassName} ${tableHeaderRounded(index)} px-2 bg-gray-50`}
            >
              <TableHeader quantityDiscount={item} />
            </th>
            <td
              className={`${tableRowClassName} flex flex-row items-center relative pl-4 pr-3 xxl:pl-2`}
            >
              <span className="flex flex-col w-full">
                <p className="text-lg leading-5 m-0">
                  {formatAsCurrency.formatIfUndefined(item.price)}
                </p>
                {!!divideByUnit && divideQuantity > 0 && (
                  <DivideByUnitPrice
                    divideByUnit={divideByUnit}
                    divideQuantity={divideQuantity}
                    price={item.price}
                    cssClass="text-xs leading-3 block"
                  />
                )}
              </span>
              {index === 0 && (
                <div
                  className={`text-center text-sm leading-4 font-bold text-black bg-yellow-400 rounded-sm ml-2 px-1 py-px w-fit ${qtyDiscountsForTable.length == 2 ? " flex flex-col md:flex-row md:space-x-1 xxl:flex-col xxl:space-x-0" : "flex flex-row space-x-1"}`}
                >
                  <span>Top</span>
                  <span>Pick</span>
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default QuantityDiscountsTableCard;
